/**
 * Colours for the dashboard's slaughter delivery widget. The same palette as the piglet registration
 * widget above it, so a week reads the same way in both: indigo is what actually happened, grey is the
 * reference it is measured against, and red is spent only on a week that fell well short.
 */
export const slaughterForecastColors = {
  /** indigo-500 - pigs actually slaughtered. */
  delivered: '#6366f1',

  /** red-500 - a delivered week under 80% of its expectation. */
  belowExpected: '#ef4444',

  /** gray-300 - the expectation. A bar rather than a line: it varies week to week with the cohort. */
  expected: '#d1d5db',

  /** gray-400 - the stripes of an expectation for a week that has not happened yet. */
  forecastStripe: '#9ca3af',

  /** gray-50 - the band behind the forecast weeks. */
  forecastBand: '#f9fafb',

  /** red-600 / green-700 - the sign of a difference, as text. */
  shortfall: '#dc2626',
  surplus: '#15803d',

  /** gray-100 - gridlines. */
  grid: '#f3f4f6',

  /** gray-900 - value labels above the bars. */
  ink: '#111827'
};
